"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DropinUtils = _interopRequireDefault(require("../../util/DropinUtils"));
var _ToolsBoardWrapper = _interopRequireDefault(require("../../components/toolsBoard/ToolsBoardWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

function ToolsBoardWrapperContainer() {
  const getToolsBoardComponent = () => (0, _DropinUtils.default)("tools-board");
  return /*#__PURE__*/_react.default.createElement(_ToolsBoardWrapper.default, {
    getToolsBoardComponent: getToolsBoardComponent
  });
}
var _default = exports.default = ToolsBoardWrapperContainer;